import * as ActionTypes from '../components/actions/types';

const initialState = [];

function eventListReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_EVENT_LISTS: {
      return action.payload;
    }
    case ActionTypes.FETCH_MORE_EVENT_LISTS: {
      return [...state, ...action.payload];
    }
    case ActionTypes.USER_LOGOUT: {
      return [];
    }
    default: {
      return state;
    }
  }
}

export default eventListReducer;



// WEBPACK FOOTER //
// ./src/reducers/eventList.js